import { createHook } from 'react-sweet-state';
import documentsPageUploadStore from "../store/documentsPageUpload";

const useDocumentPageUploadState = createHook(documentsPageUploadStore);

export default useDocumentPageUploadState;